import React from "react";
import { FaStar } from "react-icons/fa";

const CustomerRatingCard = () => {
  const customerReviews = [
    {
      id: 1,
      photo: "/person.jpg", // Sample customer photo
      name: "Emily Davis",
      rating: 4.5,
      comment: "The team at Prime Builders did an excellent job! They delivered the project on time and exceeded expectations.",
    },
    {
      id: 2,
      photo: "/person.jpg", // Sample customer photo
      name: "Michael Smith",
      rating: 5,
      comment: "Urban Developments transformed our home into a modern masterpiece. Highly recommended!",
    },
    {
      id: 3,
      photo: "/person.jpg", // Sample customer photo
      name: "Sophia Lee",
      rating: 4,
      comment: "Green Horizon Builders really care about the environment. My new home is both beautiful and eco-friendly.",
    },
  ];

  return (
    <div className="p-6">
      <div className="flex flex-wrap gap-6 justify-center">
        {customerReviews.map((review) => (
          <div
            key={review.id}
            className="relative bg-white shadow-md rounded-lg w-80 p-6 border-l-4 hover:shadow-xl hover:border-blue-600 transition duration-300 ease-in-out"
          >
            <div
              className="absolute top-0 left-0 w-full h-2 rounded-t-lg"
              style={{ backgroundColor: "#36A2EB" }}
            ></div>

            {/* Customer Photo */}
            <div className="rounded-lg overflow-hidden mb-4 flex justify-center">
              <img
                src={review.photo}
                alt={review.name}
                className="w-24 h-24 object-cover rounded-full"
              />
            </div>

            {/* Customer Details */}
            <h2 className="text-lg font-bold text-gray-800 mb-2 text-center">{review.name}</h2>

            <div className="text-center mb-4 flex items-center justify-center text-yellow-500">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} className={i < review.rating ? "text-yellow-500" : "text-gray-300"} />
              ))}
              <span className="ml-2 text-gray-600">{review.rating} Stars</span>
            </div>

            {/* Customer Comment */}
            <p className="text-sm text-gray-600 italic mb-4 text-center">
              "{review.comment}"
            </p>

            {/* Buttons */}
            {/* <div className="flex gap-4 mt-4">
              <button className="flex-1 bg-primaryOrange text-white text-sm font-semibold py-2 px-4 rounded-lg hover:bg-orange-600 transition">
                View More Reviews
              </button>
              <button className="flex-1 bg-gray-100 text-gray-700 text-sm font-semibold py-2 px-4 rounded-lg hover:bg-gray-800 hover:text-white transition">
                Reply to Review
              </button>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerRatingCard;
